let iWidth = 1440; //pc端以1440的设计稿为基准
let iMinWidth = 1004; //可视宽度小于1020，显示移动端效果图，以750的设计稿为基准
let e = window.document,
	t = e.documentElement,
	i = iWidth,
	d = i / 100,
	o = "orientationchange" in window ? "orientationchange" : "resize",
	a = function () {
		let n = t.clientWidth || 320;
		if (n >= iMinWidth) {
			//宽度为1440时，html的font-size=100px
			t.style.fontSize = n / d + "px";
		} else {
			//宽度为750时，html的font-size=100px, 使用vw单位
			t.style.fontSize = (100 / 750) * 100 + "vw";
		}
	};
e.addEventListener &&
(window.addEventListener(o, a, !1),
	e.addEventListener("DOMContentLoaded", a, !1));
